/**
 * @generated SignedSource<<6e63db2fafac3c5c6a4de8cd7c467b6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
export type PERIODICITY = "DAILY" | "WEEKLY" | "MONTHLY" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_PRICE" | "FIXED_HOURS" | "TIME_AND_MATERIALS" | "%future added value";
export type PROGRAM_BUDGET_TYPE = "UNCAPPED" | "CAPPED" | "FIXED_PRICE" | "%future added value";
export type UpdateProjectInput = {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  status?: string | null;
  active?: boolean | null;
  projectColor?: string | null;
  customProjectId?: string | null;
  clientId?: string | null;
  clientContactId?: string | null;
  salespersonId?: string | null;
  projectOwner?: string | null;
  projectManagers?: ReadonlyArray<string | null> | null;
  statusColumns?: ReadonlyArray<StatusColumnInput | null> | null;
  estimationUnit?: string | null;
  sprintTimeBox?: boolean | null;
  sprintLengthInDays?: number | null;
  projectStartYear?: number | null;
  projectStartMonth?: number | null;
  projectStartDay?: number | null;
  projectEndYear?: number | null;
  projectEndMonth?: number | null;
  projectEndDay?: number | null;
  taskLevels?: number | null;
  useTaskHierarchy?: boolean | null;
  rateCardId?: string | null;
  labels?: ReadonlyArray<string | null> | null;
  minutesPerEstimationPoint?: number | null;
  budget?: number | null;
  budgetType?: BUDGET_TYPE | null;
  defaultPeriodPriceAmount?: number | null;
  defaultPeriodHoursAmount?: number | null;
  defaultPeriodBudgetType?: PERIOD_BUDGET_TYPE | null;
  defaultPeriodLength?: number | null;
  defaultPeriodPeriodicity?: PERIODICITY | null;
  defaultPeriodSettingIgnoreForBilling?: boolean | null;
  defaultPeriodSettingSubtractValue?: boolean | null;
  defaultPeriodSettingRollValue?: boolean | null;
  defaultPeriodSettingAddExpenses?: boolean | null;
  revenueMarginLow?: number | null;
  revenueMarginHigh?: number | null;
  economicProjectId?: string | null;
  harvestProjectId?: string | null;
  newHarvestProjectId?: string | null;
  jiraProjectId?: string | null;
  jiraCutoffDate?: string | null;
  excludedHarvestTasks?: ReadonlyArray<string | null> | null;
  newExcludedHarvestTasks?: ReadonlyArray<number | null> | null;
  timelogProjectId?: string | null;
  newTimelogProjectId?: string | null;
  initTaskImport?: boolean | null;
  slackChannelId?: string | null;
  approveNoPhaseTasks?: boolean | null;
  billable?: boolean | null;
  projectGroupId?: string | null;
  previousProjectGroupId?: string | null;
  salesforceOpportunity?: string | null;
  unit4Project?: string | null;
  githubRepositories?: ReadonlyArray<string | null> | null;
  githubRepositoryIds?: ReadonlyArray<number | null> | null;
  remainingAutoCalculated?: boolean | null;
  useManualAllocations?: boolean | null;
  taskCostCalculationType?: string | null;
  unassignedTaskHourlyCost?: number | null;
  useTaskOwner?: boolean | null;
  useTaskFollowers?: boolean | null;
  currencyExchangeRate?: number | null;
  fixedPriceRateCardSetting?: number | null;
  usePublicCreateTaskPage?: boolean | null;
  usePublicCreateTaskPassword?: boolean | null;
  publicCreateTaskPassword?: string | null;
  publicCreateTaskPageStatusColumnId?: string | null;
  unsynchedJiraProject?: boolean | null;
  useBaseline?: boolean | null;
  synchBaselineAndScopingDates?: boolean | null;
  useFixedPriceForBaselineRevenue?: boolean | null;
  useDeliverables?: boolean | null;
  synchDatesSetting?: string | null;
  baselineWinChance?: number | null;
  baselineTarget?: number | null;
  priorityLevelId?: string | null;
  manualProgressOnProjectEnabled?: boolean | null;
  manualProgressOnPhasesEnabled?: boolean | null;
  manualProgressOnTasksEnabled?: boolean | null;
  flatRate?: number | null;
  flatCost?: number | null;
  financialSourceSettings?: FinancialSourceSettingsInput | null;
  sageProjectId?: string | null;
  sageIntacctLocationEntityId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type StatusColumnInput = {
  id?: string | null;
  name?: string | null;
  order?: number | null;
  category?: string | null;
  projectId?: string | null;
  projectGroupStatusColumnId?: number | null;
  autoShowOnTimePage?: boolean | null;
  encourageTimeRegistration?: boolean | null;
};
export type FinancialSourceSettingsInput = {
  plannedHours?: string | null;
  plannedRevenue?: string | null;
  plannedCost?: string | null;
  forecastHours?: string | null;
  forecastRevenue?: string | null;
  forecastCost?: string | null;
  actualHours?: string | null;
  actualRevenue?: string | null;
  actualCost?: string | null;
};
export type updateProjectBudgetPageMutationModernMutation$variables = {
  input: UpdateProjectInput;
};
export type updateProjectBudgetPageMutationModernMutation$data = {
  readonly updateProject: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly project: {
      readonly id: string;
      readonly estimationUnit: string | null;
      readonly useBaseline: boolean | null;
      readonly projectStartYear: number | null;
      readonly projectStartMonth: number | null;
      readonly projectStartDay: number | null;
      readonly projectEndYear: number | null;
      readonly projectEndMonth: number | null;
      readonly projectEndDay: number | null;
      readonly companyProjectId: number | null;
      readonly warnings: ReadonlyArray<{
        readonly id: string | null;
        readonly year: number | null;
        readonly month: number | null;
        readonly day: number | null;
        readonly tasks: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly name: string | null;
              readonly startDay: number | null;
              readonly startMonth: number | null;
              readonly startYear: number | null;
              readonly deadlineDay: number | null;
              readonly deadlineMonth: number | null;
              readonly deadlineYear: number | null;
              readonly estimateForecast: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly personIds: ReadonlyArray<string | null> | null;
        readonly expenseItems: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly name: string | null;
              readonly expenseYear: number | null;
              readonly expenseMonth: number | null;
              readonly expenseDay: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly timeRegistrations: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly year: number | null;
              readonly month: number | null;
              readonly day: number | null;
              readonly minutesRegistered: number | null;
              readonly person: {
                readonly id: string;
                readonly fullName: string | null;
                readonly profilePictureId: string | null;
                readonly profilePictureDefaultId: number | null;
              } | null;
              readonly task: {
                readonly name: string | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
      } | null> | null;
      readonly " $fragmentSpreads": FragmentRefs<"BudgetPage_project" | "expensesPage_project" | "ratesAndInternalCostPage_project">;
    } | null;
    readonly program: {
      readonly id: string;
      readonly name: string | null;
      readonly prefix: string | null;
      readonly budgetType: PROGRAM_BUDGET_TYPE | null;
      readonly projects: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly serviceCompanyId: number | null;
            readonly companyProjectId: number | null;
            readonly name: string | null;
            readonly prefix: string | null;
            readonly budgetType: BUDGET_TYPE | null;
            readonly budget: number | null;
            readonly defaultPeriodBudgetType: PERIOD_BUDGET_TYPE | null;
            readonly financialNumbers: {
              readonly allActualTimeAndExpenses: number | null;
              readonly recognitionProfitPercentage: number | null;
              readonly allTotalTimeAndExpensesAtCompletion: number | null;
              readonly forecastCostToComplete: number | null;
            } | null;
            readonly financialNumbersToDate: {
              readonly recognitionActualProfitPercentage: number | null;
              readonly allActualTimeAndExpenses: number | null;
            } | null;
            readonly totalRevenueRecognition: number | null;
            readonly totalRevenueRecognitionToDate: number | null;
            readonly totalTimeRevenueRecognitionToDate: number | null;
            readonly totalBillableExpensesAtCompletion: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly projectsFinancialsTotals: {
        readonly recognitionForecastRevenue: number | null;
        readonly allActualTimeAndExpenses: number | null;
        readonly allTotalTimeAndExpensesAtCompletion: number | null;
        readonly recognitionProfitPercentage: number | null;
        readonly recognitionActualProfitPercentage: number | null;
      } | null;
      readonly projectsFinancialsToDate: {
        readonly totalActualRevenueRecognition: number | null;
        readonly recognitionAmount: number | null;
        readonly recognitionActualProfitPercentage: number | null;
        readonly allActualTimeAndExpenses: number | null;
      } | null;
    } | null;
  } | null;
};
export type updateProjectBudgetPageMutationModernMutation = {
  variables: updateProjectBudgetPageMutationModernMutation$variables;
  response: updateProjectBudgetPageMutationModernMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useBaseline",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": (v16/*: any*/),
  "concreteType": "TaskTypeConnection",
  "kind": "LinkedField",
  "name": "tasks",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deadlineDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deadlineMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deadlineYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "estimateForecast",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "tasks(first:10000)"
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personIds",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenseYear",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenseMonth",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenseDay",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": (v16/*: any*/),
  "concreteType": "ExpenseItemTypeConnection",
  "kind": "LinkedField",
  "name": "expenseItems",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ExpenseItemTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ExpenseItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v17/*: any*/),
            (v23/*: any*/),
            (v24/*: any*/),
            (v25/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "expenseItems(first:10000)"
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesRegistered",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prefix",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budget",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultPeriodBudgetType",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allActualTimeAndExpenses",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recognitionProfitPercentage",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allTotalTimeAndExpensesAtCompletion",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "forecastCostToComplete",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recognitionActualProfitPercentage",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalRevenueRecognition",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v45 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectServiceProjectTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectServiceProjectType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceCompanyId",
            "storageKey": null
          },
          (v12/*: any*/),
          (v17/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialNumbers",
            "kind": "LinkedField",
            "name": "financialNumbers",
            "plural": false,
            "selections": [
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FinancialNumbers",
            "kind": "LinkedField",
            "name": "financialNumbersToDate",
            "plural": false,
            "selections": [
              (v40/*: any*/),
              (v36/*: any*/)
            ],
            "storageKey": null
          },
          (v41/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalRevenueRecognitionToDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalTimeRevenueRecognitionToDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalBillableExpensesAtCompletion",
            "storageKey": null
          },
          (v42/*: any*/)
        ],
        "storageKey": null
      },
      (v43/*: any*/)
    ],
    "storageKey": null
  },
  (v44/*: any*/)
],
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialNumbers",
  "kind": "LinkedField",
  "name": "projectsFinancialsTotals",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recognitionForecastRevenue",
      "storageKey": null
    },
    (v36/*: any*/),
    (v38/*: any*/),
    (v37/*: any*/),
    (v40/*: any*/)
  ],
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialNumbers",
  "kind": "LinkedField",
  "name": "projectsFinancialsToDate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalActualRevenueRecognition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recognitionAmount",
      "storageKey": null
    },
    (v40/*: any*/),
    (v36/*: any*/)
  ],
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultRate",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v50 = [
  (v3/*: any*/),
  (v17/*: any*/)
],
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v50/*: any*/),
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v53 = [
  {
    "kind": "Literal",
    "name": "convertToProjectCurrency",
    "value": true
  }
],
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualRevenue",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualCost",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiced",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billableActualMinutes",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cost",
  "storageKey": null
},
v60 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  }
],
v61 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateProjectBudgetPageMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPayload",
        "kind": "LinkedField",
        "name": "updateProject",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectFinancialWarningType",
                "kind": "LinkedField",
                "name": "warnings",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v26/*: any*/),
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "concreteType": "TimeRegTypeConnection",
                    "kind": "LinkedField",
                    "name": "timeRegistrations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRegTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeRegType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v27/*: any*/),
                              (v31/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "task",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "timeRegistrations(first:10000)"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BudgetPage_project"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "expensesPage_project"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ratesAndInternalCostPage_project"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProgramType",
            "kind": "LinkedField",
            "name": "program",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v17/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              {
                "alias": "projects",
                "args": null,
                "concreteType": "ProjectServiceProjectTypeConnection",
                "kind": "LinkedField",
                "name": "__Program_projects_connection",
                "plural": false,
                "selections": (v45/*: any*/),
                "storageKey": null
              },
              (v46/*: any*/),
              (v47/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateProjectBudgetPageMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPayload",
        "kind": "LinkedField",
        "name": "updateProject",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectFinancialWarningType",
                "kind": "LinkedField",
                "name": "warnings",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v26/*: any*/),
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "concreteType": "TimeRegTypeConnection",
                    "kind": "LinkedField",
                    "name": "timeRegistrations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRegTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TimeRegType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v27/*: any*/),
                              (v31/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "task",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "timeRegistrations(first:10000)"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "financialDataAvailability",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateDay",
                "storageKey": null
              },
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v17/*: any*/),
                  (v48/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "parentRateCardId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Role",
                    "kind": "LinkedField",
                    "name": "disabledRoles",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "concreteType": "RateTypeConnection",
                    "kind": "LinkedField",
                    "name": "rates",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RateTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Rate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rate",
                                "storageKey": null
                              },
                              (v48/*: any*/),
                              (v49/*: any*/),
                              (v51/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "rates(first:10000)"
                  }
                ],
                "storageKey": null
              },
              (v52/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnProjectEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnPhasesEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnTasksEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasInvoices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeRegBasedPlusDoneScopeCompletion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v53/*: any*/),
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineRevenue",
                    "storageKey": null
                  },
                  (v54/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableActualTimeAndExpenses",
                    "storageKey": null
                  },
                  (v55/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableForecastTimeAndExpensesToComplete",
                    "storageKey": null
                  },
                  (v39/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCostAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  (v56/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionProfit",
                    "storageKey": null
                  },
                  (v37/*: any*/),
                  (v41/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectTotalForecastTimeAndExpensesToCompleteInPast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectTotalForecastCostToCompleteInPast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsForecastCost",
                    "storageKey": null
                  },
                  (v36/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allForecastTimeAndExpensesToComplete",
                    "storageKey": null
                  },
                  (v38/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimatedCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalCostAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billablePlannedTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "registeredMinutes",
                    "storageKey": null
                  },
                  (v57/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nonBillableActualMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scopeApprovedMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedTotalMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedBillableMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedNonBillableMinutes",
                    "storageKey": null
                  }
                ],
                "storageKey": "financialNumbers(convertToProjectCurrency:true)"
              },
              {
                "alias": "financialNumbersToCurrentMonth",
                "args": (v53/*: any*/),
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionLockedProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionLockedProfitPercentage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionLockedRevenue",
                    "storageKey": null
                  }
                ],
                "storageKey": "financialNumbers(convertToProjectCurrency:true)"
              },
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": "ExpenseItemTypeConnection",
                "kind": "LinkedField",
                "name": "expenseItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExpenseItemTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExpenseItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "approved",
                            "storageKey": null
                          },
                          (v52/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "partOfFixedPrice",
                            "storageKey": null
                          },
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v58/*: any*/),
                          (v59/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "quantity",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v42/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExpenseCategory",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": (v50/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhaseType",
                            "kind": "LinkedField",
                            "name": "phase",
                            "plural": false,
                            "selections": (v50/*: any*/),
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planned",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          (v56/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "periodLocked",
                            "storageKey": null
                          },
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v44/*: any*/)
                ],
                "storageKey": "expenseItems(first:10000)"
              },
              {
                "alias": null,
                "args": (v16/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Project_expenseItems",
                "kind": "LinkedHandle",
                "name": "expenseItems"
              },
              {
                "alias": null,
                "args": (v60/*: any*/),
                "concreteType": "RetainerPeriodTypeConnection",
                "kind": "LinkedField",
                "name": "retainerPeriods",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RetainerPeriodTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetainerPeriodType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v53/*: any*/),
                            "concreteType": "FinancialNumbers",
                            "kind": "LinkedField",
                            "name": "financialNumbers",
                            "plural": false,
                            "selections": [
                              (v57/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "retainerPeriodTargetPrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "retainerPeriodRolloverPrice",
                                "storageKey": null
                              },
                              (v55/*: any*/)
                            ],
                            "storageKey": "financialNumbers(convertToProjectCurrency:true)"
                          },
                          (v3/*: any*/),
                          (v42/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v44/*: any*/)
                ],
                "storageKey": "retainerPeriods(first:100000)"
              },
              {
                "alias": null,
                "args": (v60/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "HighLevelBudgetNumbers_retainerPeriods",
                "kind": "LinkedHandle",
                "name": "retainerPeriods"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FinancialSourceSettings",
                "kind": "LinkedField",
                "name": "financialSourceSettings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualHours",
                    "storageKey": null
                  },
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useFixedPriceForBaselineRevenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v61/*: any*/),
                "concreteType": "DeliverableTypeConnection",
                "kind": "LinkedField",
                "name": "deliverables",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DeliverableTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DeliverableType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v17/*: any*/),
                          (v58/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "deliverables(first:1000)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecFirstDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecFirstDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecFirstDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecLastDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecLastDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecLastDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v61/*: any*/),
                "concreteType": "ProjectFixedPriceLockTypeConnection",
                "kind": "LinkedField",
                "name": "fixedPriceLocks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectFixedPriceLockTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectFixedPriceLockType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "locked",
                            "storageKey": null
                          },
                          (v49/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDate",
                            "storageKey": null
                          },
                          (v42/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v44/*: any*/)
                ],
                "storageKey": "fixedPriceLocks(first:1000)"
              },
              {
                "alias": null,
                "args": (v61/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_fixedPriceLocks",
                "kind": "LinkedHandle",
                "name": "fixedPriceLocks"
              },
              (v62/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taskCostCalculationType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unassignedTaskHourlyCost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v61/*: any*/),
                "concreteType": "ProjectPersonTypeConnection",
                "kind": "LinkedField",
                "name": "projectPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectPersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectPerson",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isViewer",
                                "storageKey": null
                              },
                              (v28/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "initials",
                                "storageKey": null
                              },
                              (v29/*: any*/),
                              (v30/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "active",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "permissions",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v16/*: any*/),
                                "concreteType": "CostPeriodTypeConnection",
                                "kind": "LinkedField",
                                "name": "costPeriods",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CostPeriodTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CostPeriod",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v18/*: any*/),
                                          (v19/*: any*/),
                                          (v20/*: any*/),
                                          (v59/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "costPeriods(first:10000)"
                              }
                            ],
                            "storageKey": null
                          },
                          (v51/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projectPersons(first:1000)"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100000000
                  }
                ],
                "concreteType": "InvoiceTypeConnection",
                "kind": "LinkedField",
                "name": "invoices",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InvoiceTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InvoiceType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v62/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "invoices(first:100000000)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProgramType",
            "kind": "LinkedField",
            "name": "program",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v17/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": "ProjectServiceProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": (v45/*: any*/),
                "storageKey": "projects(first:10000)"
              },
              {
                "alias": null,
                "args": (v16/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Program_projects",
                "kind": "LinkedHandle",
                "name": "projects"
              },
              (v46/*: any*/),
              (v47/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "11137e45c65485a86ebe31b88963eb16",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "updateProject",
            "program",
            "projects"
          ]
        }
      ]
    },
    "name": "updateProjectBudgetPageMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation updateProjectBudgetPageMutationModernMutation(\n  $input: UpdateProjectInput!\n) {\n  updateProject(input: $input) {\n    errors\n    project {\n      id\n      estimationUnit\n      useBaseline\n      projectStartYear\n      projectStartMonth\n      projectStartDay\n      projectEndYear\n      projectEndMonth\n      projectEndDay\n      companyProjectId\n      warnings {\n        id\n        year\n        month\n        day\n        tasks(first: 10000) {\n          edges {\n            node {\n              id\n              name\n              startDay\n              startMonth\n              startYear\n              deadlineDay\n              deadlineMonth\n              deadlineYear\n              estimateForecast\n            }\n          }\n        }\n        personIds\n        expenseItems(first: 10000) {\n          edges {\n            node {\n              id\n              name\n              expenseYear\n              expenseMonth\n              expenseDay\n            }\n          }\n        }\n        timeRegistrations(first: 10000) {\n          edges {\n            node {\n              id\n              year\n              month\n              day\n              minutesRegistered\n              person {\n                id\n                fullName\n                profilePictureId\n                profilePictureDefaultId\n              }\n              task {\n                name\n                id\n              }\n            }\n          }\n        }\n      }\n      ...BudgetPage_project\n      ...expensesPage_project\n      ...ratesAndInternalCostPage_project\n    }\n    program {\n      id\n      name\n      prefix\n      budgetType\n      projects(first: 10000) {\n        edges {\n          node {\n            id\n            serviceCompanyId\n            companyProjectId\n            name\n            prefix\n            budgetType\n            budget\n            defaultPeriodBudgetType\n            financialNumbers {\n              allActualTimeAndExpenses\n              recognitionProfitPercentage\n              allTotalTimeAndExpensesAtCompletion\n              forecastCostToComplete\n            }\n            financialNumbersToDate {\n              recognitionActualProfitPercentage\n              allActualTimeAndExpenses\n            }\n            totalRevenueRecognition\n            totalRevenueRecognitionToDate\n            totalTimeRevenueRecognitionToDate\n            totalBillableExpensesAtCompletion\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      projectsFinancialsTotals {\n        recognitionForecastRevenue\n        allActualTimeAndExpenses\n        allTotalTimeAndExpensesAtCompletion\n        recognitionProfitPercentage\n        recognitionActualProfitPercentage\n      }\n      projectsFinancialsToDate {\n        totalActualRevenueRecognition\n        recognitionAmount\n        recognitionActualProfitPercentage\n        allActualTimeAndExpenses\n      }\n    }\n  }\n}\n\nfragment ActualDetailsTable_project on ProjectType {\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        startDate\n        endDate\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...DetailsTable_project\n}\n\nfragment BudgetData_project_1TK8ll on ProjectType {\n  ...Chart_project\n  ...HighLevelBudgetNumbers_project_1TK8ll\n  ...Totals_project\n  ...InvoiceChart_project\n  ...RevenueRecognition_project\n  id\n  billable\n  budgetType\n}\n\nfragment BudgetPageHeader_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  budgetType\n  budget\n  defaultPeriodBudgetType\n  rateCard {\n    currency\n    id\n  }\n  estimationUnit\n  billable\n  manualProgressOnProjectEnabled\n  manualProgressOnPhasesEnabled\n  manualProgressOnTasksEnabled\n}\n\nfragment BudgetPage_project on ProjectType {\n  id\n  financialDataAvailability\n  ...BudgetPageHeader_project\n  ...BudgetData_project_1TK8ll\n  ...TimeBudgetData_project\n  ...Details_project\n  ...InvoiceDetails_project\n  ...TimeDetails_project\n  ...ExpenseDetails_project\n  manualProgressOnProjectEnabled\n  manualProgressOnPhasesEnabled\n  manualProgressOnTasksEnabled\n  budgetType\n}\n\nfragment Chart_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment DetailsTable_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment Details_project on ProjectType {\n  id\n  useBaseline\n  budgetType\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  estimationUnit\n  billable\n  ...DetailsTable_project\n  ...ActualDetailsTable_project\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n}\n\nfragment ExpenseDetailsTable_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment ExpenseDetails_project on ProjectType {\n  id\n  useBaseline\n  budgetType\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  billable\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n  ...ExpenseDetailsTable_project\n}\n\nfragment HighLevelBudgetNumbers_project_1TK8ll on ProjectType {\n  id\n  useBaseline\n  hasInvoices\n  budget\n  budgetType\n  defaultPeriodBudgetType\n  timeRegBasedPlusDoneScopeCompletion\n  rateCard {\n    currency\n    id\n  }\n  financialNumbers(convertToProjectCurrency: true) {\n    baselineRevenue\n    actualRevenue\n    baselineProfit\n    actualProfit\n    totalRevenueProfitAtCompletion\n    baselineMargin\n    actualMargin\n    totalRevenueMarginAtCompletion\n    billableActualTimeAndExpenses\n    actualCost\n    billableForecastTimeAndExpensesToComplete\n    forecastCostToComplete\n    totalCostAtCompletion\n    billableTotalTimeAndExpensesAtCompletion\n    invoiced\n    paid\n    recognitionProfit\n    recognitionProfitPercentage\n    totalRevenueRecognition\n    projectTotalForecastTimeAndExpensesToCompleteInPast\n    projectTotalForecastCostToCompleteInPast\n    baselineCost\n    baselineVsForecastCost\n    allActualTimeAndExpenses\n    allForecastTimeAndExpensesToComplete\n    allTotalTimeAndExpensesAtCompletion\n    baselineTimeAndExpenses\n    baselineVsBillableTotalTimeAndExpensesAtCompletion\n    estimatedCost\n    planVsTotalCostAtCompletion\n    billablePlannedTimeAndExpenses\n  }\n  financialNumbersToCurrentMonth: financialNumbers(convertToProjectCurrency: true) {\n    recognitionLockedProfit\n    recognitionLockedProfitPercentage\n    recognitionLockedRevenue\n  }\n  expenseItems(first: 10000) {\n    edges {\n      node {\n        approved\n        billable\n        partOfFixedPrice\n        expenseYear\n        expenseMonth\n        expenseDay\n        price\n        cost\n        quantity\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  retainerPeriods(first: 100000) {\n    edges {\n      node {\n        endYear\n        endMonth\n        endDay\n        financialNumbers(convertToProjectCurrency: true) {\n          billableActualMinutes\n          retainerPeriodTargetPrice\n          retainerPeriodRolloverPrice\n          actualCost\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment HighLevelTimeNumbers_project on ProjectType {\n  id\n  useBaseline\n  billable\n  financialNumbers(convertToProjectCurrency: true) {\n    registeredMinutes\n    billableActualMinutes\n    nonBillableActualMinutes\n    forecastMinutes\n    baselineMinutes\n    scopeApprovedMinutes\n    projectedTotalMinutes\n    projectedBillableMinutes\n    projectedNonBillableMinutes\n  }\n}\n\nfragment InvoiceChart_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment InvoiceDetailsTable_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment InvoiceDetails_project on ProjectType {\n  ...InvoiceDetailsTable_project\n  budgetType\n}\n\nfragment RevenueRecognition_project on ProjectType {\n  id\n  budgetType\n  deliverables(first: 1000) {\n    edges {\n      node {\n        id\n        name\n        price\n      }\n    }\n  }\n  billable\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  projectRevRecFirstDateYear\n  projectRevRecFirstDateMonth\n  projectRevRecFirstDateDay\n  projectRevRecLastDateYear\n  projectRevRecLastDateMonth\n  projectRevRecLastDateDay\n  estimationUnit\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        locked\n        startDate\n        endDate\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  rateCard {\n    currency\n    id\n  }\n}\n\nfragment TimeBudgetData_project on ProjectType {\n  ...TimeChart_project\n  ...TimeTotals_project\n  ...HighLevelTimeNumbers_project\n}\n\nfragment TimeChart_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment TimeDetails_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  ...DetailsTable_project\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n}\n\nfragment TimeTotals_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n}\n\nfragment Totals_project on ProjectType {\n  id\n  budgetType\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  estimationUnit\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n  useFixedPriceForBaselineRevenue\n}\n\nfragment expenseRow_project on ProjectType {\n  id\n  budgetType\n  companyProjectId\n}\n\nfragment expensesPage_project on ProjectType {\n  ...expenseRow_project\n  id\n  companyProjectId\n  billable\n  budgetType\n  status\n  rateCard {\n    id\n    currency\n  }\n  expenseItems(first: 10000) {\n    edges {\n      node {\n        id\n        category {\n          id\n          name\n        }\n        phase {\n          id\n          name\n        }\n        name\n        approved\n        expenseYear\n        expenseMonth\n        expenseDay\n        billable\n        partOfFixedPrice\n        price\n        cost\n        quantity\n        planned\n        createdAt\n        invoiced\n        periodLocked\n        person {\n          id\n          fullName\n          profilePictureId\n          profilePictureDefaultId\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        startDate\n        endDate\n        locked\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ratesAndInternalCostPage_project on ProjectType {\n  id\n  budget\n  budgetType\n  taskCostCalculationType\n  unassignedTaskHourlyCost\n  projectPersons(first: 1000) {\n    edges {\n      node {\n        id\n        person {\n          id\n          isViewer\n          fullName\n          initials\n          profilePictureId\n          profilePictureDefaultId\n          active\n          permissions\n          costPeriods(first: 10000) {\n            edges {\n              node {\n                id\n                startDay\n                startMonth\n                startYear\n                cost\n              }\n            }\n          }\n        }\n        role {\n          id\n          name\n        }\n      }\n    }\n  }\n  rateCard {\n    id\n    currency\n    name\n    defaultRate\n    parentRateCardId\n    disabledRoles {\n      id\n    }\n    rates(first: 10000) {\n      edges {\n        node {\n          id\n          rate\n          defaultRate\n          startDate\n          role {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n  invoices(first: 100000000) {\n    edges {\n      node {\n        status\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "91040f741a5dc4661097a8038a46dd5b";

export default node;
